<template>
  <!-- 区域管理 -->
  <div class="treeBigBox">
    <!--树形结构-->
    <div class="treeBox">
      <el-tree :data="datatree"
               :props="defaultProps"
               node-key="id"
               :highlight-current="true"
               @node-click="handleNodeClick">
      </el-tree>
    </div>
    <div class="right">
          <div id="video"></div>
    </div>
  </div>
</template>

<script>
import { getTreeList } from '@/api/video'
export default {
  inject: ['reload'],

  data () {
    return {
      datatree: [],
      defaultProps: {
        children: 'children',
        label: 'regionName'
      }

    }
  },
  created () {
    this.getListTree()
  },
  mounted () {
    this.videoFN()
  },
  methods: {

    // 视频展示
    videoFN (data, id) {
      const player = new ImouPlayer('#video')
      player.setup({
        src: [
          {
            url: 'imou://open.lechange.com/5H08FADPAJFC4FB/0/1?streamId=1', // url拼接说明请见：2.2.3 轻应用播放地址说明
            kitToken: 'Kt_03ca2b1101b6489b86a606c0755b5968' // 播放Token，通过接口getKitToken获取，具体请见：2.2.4 getKitToken接口协议说明
          }
        ], // 播放地址
        width: '100%', // 播放器宽度
        height: '100%', // 播放器高度
        poster: '', // 封面图url
        autoplay: false, // 是否自动播放
        controls: true // 是否展示控制栏
      })
    },

    getListTree () {
      this.datatree = []
      getTreeList().then(res => {
        this.datatree = res
        console.log(res)
      }).catch(error => {
        this.$message.error(error)
      })
    },
    // 点击树型结构
    handleNodeClick (data, e) {
      console.log(data)
      this.tableData = data.children
      this.shangjiName = data.regionName
      this.fatherId = data.id
    }
  }
}
</script>
<style scoped lang='less'>
  .treeBigBox {
    width: 100%;
    height: 100%;
    margin-top: -20px;
    display: flex;
  }
  .treeBox {
    width: 25%;
    height: 100%;
    padding: 20px 0 0 20px;
  }
  .right {
    width: 75%;
    height: 100%;
    border-left: solid 1px #ccc;
  }
  .right-top-title {
    height: 65px;
    margin: 20px 0 0 40px;
    display: flex;
  }
  .right-top-btn {
    line-height: 65px;
    margin-left: 40px;
  }
  .right-top-btn .el-button {
    margin-right: 20px;
  }
  .xiangQingBox {
    margin-top: 50px;
    margin-left: 60px;
  }
  .addinpBox {
    width: 60%;
    margin: 0 auto;
  }
  .addinpBox .el-input {
    width: 210px;
  }

  .demo-form-inline .el-form-item {
    margin-bottom: 17px !important;
  }

  .searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.right{
  padding: 10px;
}
</style>
